<template>
  <transition name="fade">
    <div class="preloader" v-if="preloader">
      <lottie
        :options="loading"
        class="anim"
        :height="getScreen ? 200 : 500"
        :width="getScreen ? 200 : 500"
      ></lottie>
    </div>
  </transition>
</template>

<script>
import lottie from "vue-lottie";
import loading from "@/assets/anim/loading.json";
import { mapGetters } from "vuex";
export default {
  name: "preloader",
  components: {
    lottie,
  },
  data() {
    return {
      loading: { animationData: loading, loop: true },
    };
  },
  computed: {
    ...mapGetters(["preloader", "getScreen"]),
  },
};
</script>

<style lang="less" scoped>
.preloader {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: fade(@color-dark, 70%);
  background-image: radial-gradient(
    @color-dark,
    fade(@color-dark, 70%),
    fade(@color-dark, 10%)
  );
  //   opacity: 10%;
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>